import { IsNotEmpty, IsUUID } from 'class-validator';

export class ExportAttorneyDto {
  @IsUUID()
  @IsNotEmpty()
  attorneyId: string;
}
